import { render, staticRenderFns } from "./EllipsisText.vue?vue&type=template&id=67760c2a&scoped=true"
import script from "./EllipsisText.vue?vue&type=script&lang=js"
export * from "./EllipsisText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67760c2a",
  null
  
)

export default component.exports